import React from 'react'

import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { BlogCard } from '@application/Interfaces/Features/BlogsThumbnailCards/BlogCard/BlogCard'
import { Pagination } from '@application/Interfaces/Organisms/Pagination'
import { SocialBanner } from '@application/Interfaces/Organisms/SocialBanner'
import { BlogListType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'
import { CategoryList, CategoryListExpandable } from '@src/Application/Interfaces/Organisms/CategoryList'

import {
    BannerContent,
    BannerDescription,
    BannerImage,
    BannerTitle,
    BannerWrapper,
    Button,
    Link,
    List,
    SideWrapper,
    Title,
    Wrapper,
} from './BlogList.styled'
import { mapToBlogCard } from './utils'

export const BlogList = ({
    sectionTitle,
    items,
    categories,
    prevPage,
    nextPage,
    showCategories,
    bannerTitle,
    bannerDescription,
    bannerLinkUrl,
    bannerLinkLabel,
    bannerImage,
    bannerImageAnimation,
    showBanner,
    socialBannerTitle,
    socialBannerDescription,
    facebookLink,
    linkedInLink,
    twitterLink,
    socialButtonUrl,
    socialButtonLabel,
    showSocialBanner,
}: BlogListType): JSX.Element => {
    const WrapperTilt = bannerImageAnimation ? Tilt : React.Fragment

    return (
        <Container>
            <Wrapper>
                <List>
                    <Title>{sectionTitle}</Title>
                    {showCategories && <CategoryListExpandable categories={categories} label="chooseCategory" />}
                    <Grid container>
                        {mapToBlogCard(items).map((item, i) => (
                            <Grid item xs={12} md={6} spacingBottom={10} key={`blog-item-${i}`}>
                                <BlogCard item={item} mode="Light" />
                            </Grid>
                        ))}
                    </Grid>
                    <Pagination prevPage={prevPage} nextPage={nextPage} />
                </List>

                <SideWrapper>
                    {showCategories && <CategoryList categories={categories} label="chooseCategory" />}
                    {showBanner && (
                        <WrapperTilt>
                            <BannerWrapper>
                                <BannerImage image={bannerImage} />
                                <BannerContent>
                                    <BannerTitle>{bannerTitle}</BannerTitle>
                                    <BannerDescription>{bannerDescription}</BannerDescription>
                                    <Link to={bannerLinkUrl}>
                                        <Button>{bannerLinkLabel}</Button>
                                    </Link>
                                </BannerContent>
                            </BannerWrapper>
                        </WrapperTilt>
                    )}
                    <SocialBanner
                        socialBannerTitle={socialBannerTitle}
                        socialBannerDescription={socialBannerDescription}
                        facebookLink={facebookLink}
                        linkedInLink={linkedInLink}
                        twitterLink={twitterLink}
                        socialButtonUrl={socialButtonUrl}
                        socialButtonLabel={socialButtonLabel}
                        showSocialBanner={showSocialBanner}
                    />
                </SideWrapper>
            </Wrapper>
        </Container>
    )
}
